import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import useGlobalStyles from '../../../useGlobalStyles';
import { AwardedAward } from '../../../../types';
import useAwardItemStyles from './useAwardItemStyles';
import { AWARDS } from '../../baseComponents/award';

/**
 * Awards component that renders the user's awards.
 * @param awards - the list of awards to display.
 * @returns - the Awards component.
 */
const AwardItem: React.FC<{ awardedAward: AwardedAward }> = ({ awardedAward }) => {
  const { classes } = useAwardItemStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const award = AWARDS.find(a => a.key === awardedAward.award)?.value;
  if (!award) {
    return null;
  }

  return (
    <Tooltip
      title={award.description}
      placement='top'
      classes={{ tooltip: globalClasses.tooltip }}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -25],
            },
          },
        ],
      }}>
      <div className={classes.awardItemContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/awards/${award.icon}`}
          alt={award.name}
          className={classes.icon}
        />
        <div className={`${globalClasses.h6} ${classes.name}`}>{award.name}</div>
        <p className={`${globalClasses.p} ${classes.count}`}>{awardedAward.count}</p>
      </div>
    </Tooltip>
  );
};

export default AwardItem;
